const defaultState = {
  reportTypes: null,
  error: null,
  fetching: false,
  fetched: false
};

const getReportTypesReducer = (state = defaultState, action) => {
  switch (action.type) {
    case 'REPORT_TYPES_FETCH_PENDING': {
      return {
        ...state, error: null, fetching: true
      };
    }
    case 'REPORT_TYPES_FETCH_FULFILLED': {
      return {
        ...state, fetching: false, fetched: true, error: null, reportTypes: action.payload.data
      };
    }
    case 'REPORT_TYPES_FETCH_REJECTED': {
      return {
        ...state,
        fetching: false,
        fetched: false,
        customers: null,
        error: action.payload
      };
    }
    default: {
      break;
    }
  }

  return state;
};

export default getReportTypesReducer;


// WEBPACK FOOTER //
// ./src/reducers/getReportTypes.js